$(document).ready(function () {

    $(".hamburger").click(function (e) {
        e.stopPropagation();
        $(this).toggleClass("is-active");
        $('.menu-header-mobile').toggleClass('open')
        // $('body').toggleClass('overflow-hidden')
    });

    $(document).on('click', function(e) {
      var $menu = $('.menu-header-mobile');
      if ($menu.hasClass('open')) {
        if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
          $menu.removeClass('open');
        }
      }
    });

    $(".btn-categories").click(function (e) {
        $('.content-categories').toggleClass('show');
    });
  
    
    // $(window).on("scroll", function () {
    //     $("body").toggleClass("down", ($(window).scrollTop() > 180));
    // });

    const videos = document.querySelectorAll('.custom-video');
  
    videos.forEach(function(video) {
      video.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    });
    
    if ($('body').hasClass('has-loading')) {
        $('.loading-container').delay(500).fadeOut(400);
        setTimeout(() => {
            AOS.init({
                duration: 1000, // values from 0 to 3000, with step 50ms
                easing: 'ease', // default easing for AOS animations
            });
        }, 1000);
    } else {
        AOS.init({
            duration: 1000, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
        });
    }

    var thumbSwiper = new Swiper(".thumbSwiper", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
  
    var productsSwiper = new Swiper(".productsSwiper", {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: thumbSwiper,
        },
    });

  
    var defaultSwiper = new Swiper(".defaultSwiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 4,
                spaceBetween: 45,
            },
        },
    });

    var testiSwiper = new Swiper(".testiSwiper", {
        // scrollbar: {
        //     el: ".swiper-scrollbar",
        //     draggable: true,
        // },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 20,
            },
            576: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.8,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 2.5,
                spaceBetween: 45,
            },
        },
    })
})